module.exports = __webpack_public_path__ + "img/image-logo-01.50e31db9.png";